export enum ElementsStartDate {
  START_DELAYED = "START_DELAYED",
  STARTS_TODAY = "STARTS_TODAY",
  STARTS_THIS_WEEK = "STARTS_THIS_WEEK",
  STARTS_THIS_MONTH = "STARTS_THIS_MONTH",
}

export enum ElementsDueDate {
  PAST_DUE = "PAST_DUE",
  DUE_TODAY = "DUE_TODAY",
  DUE_THIS_WEEK = "DUE_THIS_WEEK",
  DUE_THIS_MONTH = "DUE_THIS_MONTH",
}
